import React, { memo, useMemo } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors, resolveColor } from "utils/styles";
import Content from "./Content";
// import ContentTitle from "./ContentTitle";
import ButtonGroup from "./ButtonGroup";
// import Title from "./Title";
// import MediaCardCTA from "./MediaCardCTA";
import Media from "./Media";
import renderItem from "utils/renderItem";
import DynamicLink from "./DynamicLink";
import ConditionalWrapper from "components/Reusables/ConditionalWrapper";
import ImageLabel from "./ImageLabel";
//Media Card
const ImageCard = memo(function ImageCard(props) {
	const { sectionIndex, data, inline = false } = props;
	const fields = data?.fields;

	const cardConfig = useMemo(() => ({
		imageContainerClasses: fields?.imageContainerClass || " ",
		contentClasses: fields?.contentAreaClasses || " ",
		alignImage: fields?.alignImage || "center",
		flexDirection: fields?.flexDirection || "flex-column",
		display: inline ? "d-inline-flex" : "d-flex"
	}), [fields?.imageContainerClass, fields?.contentAreaClasses, fields?.alignImage, fields?.flexDirection, inline]);
	return (
		<div
			className={`imageCard ${cardConfig.display} justify-content-${cardConfig.alignImage} ${
				fields?.cardClass || " "
			}`}
		>
			<ConditionalWrapper
				condition={fields?.pathOrUrl && fields?.cardLink}
				wrapper={(children) => (
					<DynamicLink classes="w-100" href={fields?.pathOrUrl}>
						{children}
					</DynamicLink>
				)}
			>
				<Row className={` g-0  d-flex ${cardConfig.flexDirection} w-100`}>
					{/* Media card image */}
					{(fields?.media || fields?.vimeoId || fields?.audioUrl) && (
						<Col xs={12} className={`flex-grow-0  d-flex justify-content-${cardConfig.alignImage}`}>
							<div
								className={` ${cardConfig.imageContainerClasses} relative imageContainer ${
									fields?.vimeoId ? "w-100" : ""
								}`}
							>
								<Media data={data} sectionIndex={sectionIndex} />

								{fields?.imgLabel && (
									<ImageLabel
										position={fields?.labelPosition}
										backGround={fields?.imgLabelBackgroundColor}
										label={fields?.imgLabel}
									/>
								)}
							</div>
						</Col>
					)}
					{/* Media card content (title, content, buttons) */}
					{(fields?.contents || fields?.description || fields?.buttons) && (
						<Col xs={12} className={`d-flex  flex-grow-1 flex-column`}>
							<div className={`imageCardContent   ${cardConfig.contentClasses} flex-grow-1 d-flex flex-column `}>
								{fields?.contents &&
									fields?.contents.map((content) => {
										const type = content.sys.contentType.sys.id;
										let ContentItem = <></>;

										switch (type) {
											case "title":
												ContentItem = renderItem(content); //<Title title={content} />;
												break;

											case "content":
												ContentItem = renderItem(content); //<Content content={content} />;
												break;

											case "buttonGroup":
												ContentItem = renderItem(content); //<ButtonGroup buttonGroupData={content} />;
												break;
											// case "cta":
											// 	// ContentItem = renderItem(content); //<MediaCardCTA content={content} />;
											// 	break;

											default:
												console.error("type ", type);
												return <></>;
												break;
										}

										return <React.Fragment key={content.sys.id}>{ContentItem}</React.Fragment>;
									})}

								{fields?.description && <Content content={fields?.description} />}

								{/* Call to action button group */}
								{fields?.buttons && <ButtonGroup buttonGroupData={fields?.buttons} />}
							</div>
						</Col>
					)}
				</Row>
			</ConditionalWrapper>

			<style jsx="true">{`
				.imageContainer {
					background: ${resolveColor(fields?.imageBackgroundColor) || "transparent"};
				}
				.imageCard {
					max-height: 100%;
					background: ${resolveColor(fields?.contentBackgroundColor) || "transparent"};
				}
				.imageCardContent {
					min-height: ${fields?.contentMinHeight ? fields?.contentMinHeight + "px" : "inherit"};
				}
				@media screen and (min-width: 992px) {
					.details {
						background: ${colors.white};
					}
				}
				.bottom {
					bottom: 1.5em;
					position: absolute;
				}
				.link {
					font-family: "Open Sans";
					font-size: 15px;
					font-weight: bold;
					line-height: 18px;
					letter-spacing: 0px;
					margin: 0;
					letter-spacing: 1px;
					color: ${colors.darkBlue};
				}
			`}</style>
		</div>
	);
});

export default ImageCard;
